import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

import { computePopupWidth, MIN_POPUP_WIDTH } from './popupWidth.js';

import './YamlEditorPopup.css';

//Text editor popup for a recording's yaml files. show(recording, filePath) loads the file
//(served statically under maps/) into the textarea. The corner close icon discards any edits
//and closes; Save posts the textarea contents to the recording_file_save servlet and closes
//on success, or shows the servlet's error and stays open. Contents live only in component
//state, so closing genuinely discards them.
class YamlEditorPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false,
            recording: '',
            filePath: '',
            content: '',
            errMsg: '',
            popupWidth: MIN_POPUP_WIDTH
        };

        this.titleBarRef = React.createRef();
    }

    //react-bootstrap's Modal owns the .modal-dialog element and does not forward a style
    //prop to it, so the computed width is applied imperatively after each open/update by
    //walking up from an element we do own. The css caps it at the screen width. Width is
    //computed from the loaded file only -- typing a longer line scrolls rather than resizes.
    componentDidUpdate() {

        if (this.state.showPopup && this.titleBarRef.current)
        {
            const dialog = this.titleBarRef.current.closest('.modal-dialog');

            if (dialog)
            {
                dialog.style.width = this.state.popupWidth + 'px';
            }
        }
    }

    show = (recording, filePath) => {

        //load through the servlet, which reads the disk directly: the static maps/ path goes
        //through Tomcat's resource cache (cacheTtl, ~5s), so reopening quickly after a save
        //would show the pre-save contents. Servers without the servlet yet fall back to the
        //static path with the browser cache bypassed (correct except for that ~5s window).
        fetch('recording_file_load', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "recording=" + encodeURIComponent(recording) +
                  "&filename=" + encodeURIComponent(filePath)
        })
        .then((res) => {
            if (res.ok)
            {
                return res.text();
            }

            return fetch('maps/' + recording + '/' + filePath, { cache: 'no-store' })
                   .then(fallbackRes => fallbackRes.text());
        })
        .then((text) => {
            this.setState({
                showPopup: true,
                recording: recording,
                filePath: filePath,
                content: text,
                errMsg: '',
                popupWidth: computePopupWidth(text)
            });
        })
        .catch(console.log)
    }

    handleClose = () => {
        this.setState({
            showPopup: false,
            content: '',
            errMsg: ''
        });
    }

    handleContentChange = (event) => {
        this.setState({ content: event.target.value });
    }

    handleSave = () => {

        fetch('recording_file_save', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "recording=" + encodeURIComponent(this.state.recording) +
                  "&filename=" + encodeURIComponent(this.state.filePath) +
                  "&content=" + encodeURIComponent(this.state.content)
        })
        .then(res => res.json())
        .then((data) => {
            if ('true' === data[0].saved)
            {
                this.handleClose();

                if (this.props.onSaved)
                {
                    this.props.onSaved();
                }
            }
            else
            {
                this.setState({ errMsg: data[0].errMsg });
            }
        })
        .catch((err) => {
            //a 404 (servlet not deployed) or network failure must not look like success
            console.log(err);
            this.setState({ errMsg: 'Save failed - is the save service deployed on this server?' });
        })
    }

    render() {
        return (
            <Modal
              className="yamlEditorRoot"
              backdropClassName="yamlEditorBackdrop"
              dialogClassName="yamlEditorModal"
              show={this.state.showPopup}
              onHide={this.handleClose}
              backdrop="static"
              animation={false}
              centered
            >
            <Modal.Body className="yamlEditorBody">
                <div className="yamlEditorTitleBar" ref={this.titleBarRef}>
                    <span className="yamlEditorTitle">{this.state.filePath}</span>
                    <button type="button" className="yamlEditorClose" aria-label="Close editor" onClick={this.handleClose}>
                        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
                            <path d="M3 3 L13 13 M13 3 L3 13" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
                <textarea
                    className="yamlEditorTextarea"
                    value={this.state.content}
                    onChange={this.handleContentChange}
                    spellCheck={false}
                    wrap="off"
                />
            </Modal.Body>

            <Modal.Footer className="yamlEditorFooter">
                <span className="yamlEditorError">{this.state.errMsg}</span>
                <Button onClick={this.handleSave}>Save</Button>
            </Modal.Footer>
            </Modal>
        )
    }
}

export default YamlEditorPopup;
